import { useAuthStore } from "../../../features/auth/services/useAuthStore";

export function authFetch(
  input: RequestInfo,
  init?: RequestInit
): Promise<Response> {
  const { token } = useAuthStore.getState();

  const headers = new Headers(init?.headers || {});
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  return fetch(input, { ...init, headers });
}
